






















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import BackofficeTempoCirurgicoPorProcedimentoStore from '@/components/Backoffice/Store/BackofficeTempoCirurgicoPorProcedimentoStore'
import { DataTablePagination } from '@/types/_'
import { onlyNumber, onlyNumberAndNewLine } from '@/utils/common'
import { useHospitais } from '@/composables'

@Component
export default class ViewBackofficeTempoCirurgicoPorProcedimento extends Vue {
  $refs!: { formTempoCirurgicoParametrizado: any }

  procedimentoType: 'medico' | 'hospital' = 'hospital'
  loadHospital: boolean = false
  loadTempoCirurgicoPorProcedimentoList: boolean = false

  get getBackofficeTempoCirurgicoPorProcedimentoStore() {
    return getModule(BackofficeTempoCirurgicoPorProcedimentoStore, this.$store)
  }

  get paginationTempoCirurgicoPorProcedimento() { return this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimento }

  get loadingTempoCirurgicoPorProcedimentoList() { return this.loadTempoCirurgicoPorProcedimentoList }
  set loadingTempoCirurgicoPorProcedimentoList(value: boolean) { this.loadTempoCirurgicoPorProcedimentoList = value }

  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }
  get hospitalId() { return this.getBackofficeTempoCirurgicoPorProcedimentoStore.hospitalId }
  set hospitalId(value: string) { this.getBackofficeTempoCirurgicoPorProcedimentoStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }


  get tempoCirurgicoPorProcedimentoHeaders() {
    return [
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'Procedimento', value: 'descricao', sortable: false },
      { text: 'Tempo cirúrgico mínimo (minutos)', value: 'tempoCirurgicoMinimoEmMinutos', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get searchTempoCirurgicoPorProcedimento() { return this.getBackofficeTempoCirurgicoPorProcedimentoStore.searchTempoCirurgicoPorProcedimento }
  set searchTempoCirurgicoPorProcedimento(value: string) { this.getBackofficeTempoCirurgicoPorProcedimentoStore.setSearchTempoCirurgicoPorProcedimento(value) }

  @Watch('searchTempoCirurgicoPorProcedimento')
  async onChangeSearchTempoCirurgicoPorProcedimento(value: any) {
    this.tempoCirurgicoPorProcedimentoPagedDebounce({ ...this.paginationTempoCirurgicoPorProcedimento })
  }

  async hospitalChange(id: any) {
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setSearchTempoCirurgicoPorProcedimento('')
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    this.loadingHospital = true
    await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoPagedSearch({
      ...params,
      ...this.getBackofficeTempoCirurgicoPorProcedimentoStore.tempoCirurgicoPorProcedimentoPaginationDefault,
    })
    await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoMedicoPagedSearch({
      ...params,
      ...this.getBackofficeTempoCirurgicoPorProcedimentoStore.tempoCirurgicoPorProcedimentoMedicoPaginationDefault,
    })
    await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getAllMedicosByHospitalId()
    await this.getBackofficeTempoCirurgicoPorProcedimentoStore.getProcedimentos()
    this.loadingHospital = false
  }

  get tempoCirurgicoPorProcedimentoList() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.tempoCirurgicoPorProcedimentoList
  }

  tempoCirurgicoPorProcedimentoPagedDebounce = _.debounce(param => this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoPagedSearch(param), 700)

  async updatePaginationTempoCirurgicoPorProcedimento(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingTempoCirurgicoPorProcedimentoList = true
    this.tempoCirurgicoPorProcedimentoPagedDebounce(pagination)
    this.loadingTempoCirurgicoPorProcedimentoList = false
  }

  adicionarTempoCirurgicoPorProcedimento(procedimentoType: 'hospital' |'medico' = 'hospital') {
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setMode({ mode: 'CREATE' })
    this.procedimentoType = procedimentoType
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearTempoCirurgicoPorProcedimento()
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setModal({ name: 'tempoCirurgicoPorProcedimento', value: true })
  }

  editarTempoCirurgicoPorProcedimento(item: any, procedimentoType: 'hospital' | 'medico' = 'hospital') {
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setMode({ mode: 'EDIT' })
    this.procedimentoType = procedimentoType
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setTempoCirurgicoPorProcedimento({ ...item })
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.setModal({ name: 'tempoCirurgicoPorProcedimento', value: true })
  }

  get paginationTempoCirurgicoPorProcedimentoMedico() { return this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimentoMedico }

  get tempoCirurgicoPorProcedimentoMedicoHeaders() {
    return [
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'Procedimento', value: 'descricao', sortable: false },
      { text: 'Médico', value: 'medicoNome', sortable: false },
      { text: 'Tempo cirúrgico mínimo (minutos)', value: 'tempoCirurgicoMinimoEmMinutos', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get searchTempoCirurgicoPorProcedimentoMedico() { return this.getBackofficeTempoCirurgicoPorProcedimentoStore.searchTempoCirurgicoPorProcedimentoMedico }
  set searchTempoCirurgicoPorProcedimentoMedico(value: string) { this.getBackofficeTempoCirurgicoPorProcedimentoStore.setSearchTempoCirurgicoPorProcedimentoMedico(value) }

  get tempoCirurgicoPorProcedimentoMedicoList() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.tempoCirurgicoPorProcedimentoMedicoList
  }

  tempoCirurgicoPorProcedimentoMedicoPagedDebounce = _.debounce(param => this.getBackofficeTempoCirurgicoPorProcedimentoStore.getTempoCirurgicoPorProcedimentoMedicoPagedSearch(param), 700)

  /**
   * Tempo Cirurgico parametrizado
   */
  get medicos() {
    return this.getBackofficeTempoCirurgicoPorProcedimentoStore.medicos || []
  }

  onlyNumberUtil(value: string | undefined) {
    return onlyNumber(value)
  }

  onlyNumberAndNewLineUtil(value: string | undefined) {
    return onlyNumberAndNewLine(value)
  }

  pasteNumeric(event: ClipboardEvent) {
    event.preventDefault()
    const numericPattern = /[^0123456789\n]+/ig
    // @ts-ignore
    const stringPattern = (event.clipboardData || window.clipboardData).getData('text') as String
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.cargaDeTempoCirurgicoParametrizado.codigosTuss = stringPattern.trim().replace(numericPattern, '')
  }

  formatErrorMessage(errorMessage: string) {
    if (['', undefined, null].includes(errorMessage)) return { message: '', length: 0 }
    const messages = errorMessage.split('|')
    const message = messages.length > 1
      ? messages.map((item: any) => `<li style="padding:0;margin:0;list-style:none">${item}</li>`).join('')
      : messages[0]
    return { message, length: messages.length }
  }

  validateTempoCirurgicoMinimoEmMinutos(value: any) {
    const tempo: number = Number.isNaN(value) ? 0 : Number(value)
    return tempo >= 15 || 'Tempo cirurgico deve ser maior ou igual a 15 minutos'
  }

  formTempoCirurgicoParametrizadoRules = {
    valid: true,
    medicoId: [],
    codigosTuss: [(v: any) => !!v.length || 'Campo obrigatório.'],
    tempoCirurgicoMinimoEmMinutos: [(v: any) => this.validateTempoCirurgicoMinimoEmMinutos(v)],
  }

  loadSaveCargaTempoCirurgicoParametrizado: boolean = false
  get loadingSaveCargaTempoCirurgicoParametrizado() { return this.loadSaveCargaTempoCirurgicoParametrizado }
  set loadingSaveCargaTempoCirurgicoParametrizado(value: boolean) { this.loadSaveCargaTempoCirurgicoParametrizado = value }

  async cargaTempoCirurgicoParametrizado() {
    this.loadingSaveCargaTempoCirurgicoParametrizado = true
    if (this.$refs.formTempoCirurgicoParametrizado.validate()) {
      const response = await this.getBackofficeTempoCirurgicoPorProcedimentoStore.cargaTempoCirurgicoParametrizado()
      if (!response.success || response.data !== '') {
        const responseError: string = response.data || response.message
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${this.formatErrorMessage(responseError).message} ${this.formatErrorMessage(responseError).length <= 1 ? String.fromCodePoint(0x1F615) : ''}`,
          icon: 'warning',
          color: '#C62828',
          dismissible: this.formatErrorMessage(responseError).length > 1,
          acceptHTML: this.formatErrorMessage(responseError).length > 1,
        })
        this.loadingSaveCargaTempoCirurgicoParametrizado = false
        return
      }

      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Procedimento(s) adicionado(s) sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })

      this.tempoCirurgicoPorProcedimentoPagedDebounce(this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimento)
      this.tempoCirurgicoPorProcedimentoMedicoPagedDebounce(this.getBackofficeTempoCirurgicoPorProcedimentoStore.paginationTempoCirurgicoPorProcedimentoMedico)
      this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearCargaDeTempoCirurgicoParametrizado()
      this.$refs.formTempoCirurgicoParametrizado.resetValidation()
    }
    this.loadingSaveCargaTempoCirurgicoParametrizado = false
  }
  /**/

  @Watch('searchTempoCirurgicoPorProcedimentoMedico')
  async onChangeSearchTempoCirurgicoPorProcedimentoMedico(value: any) {
    this.tempoCirurgicoPorProcedimentoMedicoPagedDebounce({ ...this.paginationTempoCirurgicoPorProcedimentoMedico })
  }

  beforeDestroy() {
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearTempoCirurgicoPorProcedimentoList()
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearTempoCirurgicoPorProcedimento()
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearProcedimentos()
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearMedicos()
    this.getBackofficeTempoCirurgicoPorProcedimentoStore.clearHospitalId()
    this.$refs.formTempoCirurgicoParametrizado.resetValidation()
    this.$refs.formTempoCirurgicoParametrizado.reset()
    this.procedimentoType = 'hospital'
  }
}
